import "./radio-button.component.scss";

import { memo } from "react";
import { useTranslation } from "react-i18next";

const RadioButton = props => {
  const {
    id,
    type,
    name,
    value,
    checked,
    inputClassName,
    labelClassName,
    label,
    htmlFor,
    style,
    isInvalid,
    isHide,
    disabled,
    onClick,
    onChange,
    onFocus,
    onBlur,
    ...other
  } = props;
  const { t } = useTranslation();

  const classNameList = {
    "disabled": "disabled"
  }

  const typeClassName = classNameList[type];
  const disabeldClassName = !!disabled ? classNameList["disabled"] : "";

  return (
    <>
      {!isHide &&
        <div className={`radio-input ${typeClassName} ${disabeldClassName}`} style={style}>
          <input
            id={id}
            type='radio'
            name={name}
            value={value || ''}
            checked={!!checked}
            className={inputClassName}
            disabled={disabled}
            onClick={onClick}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            {...other}
          />
          <label
            htmlFor={htmlFor || id}
            className={'text ' + labelClassName}
          >
            {t(label)}
          </label>
        </div>
      }
    </>
  );
};

export default memo(RadioButton);